import * as React from "react"

const SvgConsentOneB = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 951 1080"
  >
    <defs>
      <pattern
        id="Unnamed_Pattern"
        data-name="Unnamed Pattern"
        width={131}
        height={104}
        patternTransform="translate(-789.25 2049.03) scale(0.65 0.6)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#97459a" />
      </pattern>
      <pattern
        id="Unnamed_Pattern-3"
        data-name="Unnamed Pattern"
        width={131}
        height={104}
        patternTransform="translate(-964.44 2049.03) scale(0.68 0.6)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#97459a" />
      </pattern>
      <clipPath id="clip-path">
        <path
          d="M509.16,417.57c-36.52,7.81-96.21,88.81-107.33,87.51-21.22-2.5-47.77-61.15-47.77-61.15-14.35-1.65-41.26,11-41.26,11,2.63,33.61,47.87,120.79,66.14,121.6,36.42,1.63,62.26-24.95,76.54-43.14,0,0-17.64,48.7-14.18,92.49,0,0,35,1.41,32.73-10.67-5.48-29.69,4.69-42.56,6-83.78C482.19,464.69,509.16,417.57,509.16,417.57Z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          d="M574.77,417.58s25.07,1.3,36.2,8.6c48.39,31.73,76.22,121.8,63.83,140.75-16.25,24.88-60,38.79-60,38.79-6.3,61.22,10.08,108.94,10.08,108.94-7.89,7.87-32.51.87-54.6,7.19a234.62,234.62,0,0,1-74.59,8.26c6.61-23.7,20-47.63,18.74-84.74-2.31-67.11-5.64-70.17,8.82-134.87C529.15,483.86,534.85,460.6,574.77,417.58Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="New_Pattern_Swatch_8"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(0.68, -0.69, 0.69, 0.68, -2844, 2932.33)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <pattern
        id="Unnamed_Pattern-5"
        data-name="Unnamed Pattern"
        width={131}
        height={104}
        patternTransform="translate(-1202 2301)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#97459a" />
      </pattern>
    </defs>
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M0-1.5v725s77.25-437.82,470-338C948.56,507.13,950.9,8.39,950.91.59"
          fill="#351377"
        />
      </g>
      <g id="Layer_8" data-name="Layer 8">
        <rect
          x={186}
          y={223.5}
          width={553}
          height={94}
          rx={12}
          fill="#f9cebd"
        />
        <g>
          <rect
            x={811.1}
            y={642.68}
            width={23.67}
            height={33.37}
            transform="translate(-194.35 381.66) rotate(-23.43)"
            fill="#305387"
          />
          <path
            d="M768.57,722.36h0a11.91,11.91,0,0,1,4.85-15h0a48.26,48.26,0,0,0,23.64-43.22l-.64-18a1.76,1.76,0,0,1,2.07-1.79l3.23.58a11.16,11.16,0,0,1,8.23,6.53l7.14,16.47a8.35,8.35,0,0,0,11,4.35h0a8.36,8.36,0,0,0,4.34-11l-7.34-16.93a5.47,5.47,0,0,1,2.84-7.18l1.62-.7a.56.56,0,0,1,.73.29s6.06,5.57,21.76,43.51c.58,1.41-.38,6.09-.38,6.09l-20.81,9.93-3.32-2.77L810.32,708l-36.81,16Z"
            fill="#a9c9c3"
          />
          <path
            d="M768.57,722.36l36.54-15.84a48.88,48.88,0,0,0,12-7.46l4-3.41A43.84,43.84,0,0,1,832,688.93l20-8.67a.86.86,0,0,1,1.14.45l.67,1.54a8.59,8.59,0,0,1-4.46,11.3l-17,7.34a1.69,1.69,0,0,1-2.21-.86l-.84-1.91a1.11,1.11,0,0,0-1.73-.4L820,704a54.15,54.15,0,0,1-13.14,8.09L776.28,725.4a5.87,5.87,0,0,1-7.71-3Z"
            fill="#305387"
          />
        </g>
        <g>
          <rect
            x={757.51}
            y={785.53}
            width={33.37}
            height={23.67}
            transform="translate(-265.3 1190.6) rotate(-66.57)"
            fill="#305387"
          />
          <path
            d="M828.56,860.36h0a11.91,11.91,0,0,0-4.85-15h0a48.26,48.26,0,0,1-23.64-43.22l.64-18a1.76,1.76,0,0,0-2.07-1.79l-3.23.58a11.16,11.16,0,0,0-8.23,6.53L780,805.91a8.35,8.35,0,0,1-11,4.35h0a8.36,8.36,0,0,1-4.34-11l7.34-16.93a5.46,5.46,0,0,0-2.84-7.18l-1.62-.7a.56.56,0,0,0-.73.29s-6.06,5.57-21.75,43.51c-.59,1.41.37,6.09.37,6.09l20.81,9.93,3.32-2.77L786.81,846l36.81,16Z"
            fill="#a9c9c3"
          />
          <path
            d="M828.56,860.36,792,844.52a48.88,48.88,0,0,1-12-7.46l-4-3.41a43.84,43.84,0,0,0-10.84-6.72l-20-8.67a.87.87,0,0,0-1.15.45l-.67,1.54a8.59,8.59,0,0,0,4.46,11.3l17,7.34a1.69,1.69,0,0,0,2.21-.86l.84-1.91a1.11,1.11,0,0,1,1.73-.4l7.6,6.32a54.15,54.15,0,0,0,13.14,8.09l30.62,13.27a5.87,5.87,0,0,0,7.71-3Z"
            fill="#305387"
          />
        </g>
        <g>
          <g>
            <path d="M105.13,790.33v0" fill="#fce4d5" />
            <path
              d="M105.2,775.15l27,9.11a1.83,1.83,0,0,1,1,.87,1.73,1.73,0,0,1,.11,1.32l-14.42,44.87c-.22.61-.56,1.86-.11,2.34,0,0,13.51,16.51,17.16,21.48,4.35,5.94,5.17,12.65.94,16.9a14.85,14.85,0,0,1-10.43,4.66,13.68,13.68,0,0,1-10.14-4.34c-5.79-5.69-18.15-17.65-25.08-21.08-7.55-3.73-9.46-13.66-6.81-21.51l18.49-53.44a1.76,1.76,0,0,1,2.3-1.18Z"
              fill="#f5d5c1"
            />
          </g>
          <polygon
            points="98.51 789.02 129.27 798.99 130.18 796.17 99.48 786.22 98.51 789.02"
            fill="#f46852"
          />
          <polygon
            points="95.78 796.9 126.72 806.92 127.62 804.12 96.75 794.11 95.78 796.9"
            fill="#f46852"
          />
        </g>
        <g>
          <g>
            <path d="M780.8,355.33v0" fill="#fce4d5" />
            <path
              d="M780.73,340.15l-27,9.11a1.83,1.83,0,0,0-1,.87,1.73,1.73,0,0,0-.11,1.32l14.42,44.87c.22.61.56,1.86.12,2.34,0,0-13.52,16.51-17.16,21.48-4.36,5.94-5.18,12.65-1,16.9a14.87,14.87,0,0,0,10.44,4.66,13.65,13.65,0,0,0,10.13-4.34c5.79-5.69,18.15-17.65,25.08-21.08,7.55-3.73,9.46-13.66,6.81-21.51L783,341.33a1.74,1.74,0,0,0-.88-1.09,1.8,1.8,0,0,0-1.42-.09Z"
              fill="#f5d5c1"
            />
          </g>
          <polygon
            points="787.42 354.02 756.66 363.99 755.76 361.17 786.45 351.22 787.42 354.02"
            fill="#f46852"
          />
          <polygon
            points="790.15 361.9 759.21 371.93 758.31 369.12 789.18 359.11 790.15 361.9"
            fill="#f46852"
          />
        </g>
      </g>
      <g id="Background">
        <path
          d="M171.55,266.72C141.93,280.26,173.77,420.43,174,450c3,350.47,568.28,189.5,568.28,189.5-36.73-136.49,52.94-367.9-8.45-367.88,0,0-125.52,0-269.2-4.34C356,264,209,249.61,171.55,266.72Z"
          fill="#dbd1e5"
        />
        <path
          d="M516.73,245.55c-12.23,4.73-13.46,29.24-9.51,52.23,3.39,19.82-10,29.54-4.75,46.21,4.65,14.66,44.32,25.08,85.59,29.68,31,3.46,55.14,16.89,77,7.21,27.14-12,90.87-82.66,70.26-95.2-19.83-12.07-95.72-12.83-122.91-17.47C586.82,263.84,531.63,239.78,516.73,245.55Z"
          fill="url(#Unnamed_Pattern)"
        />
        <path
          d="M735.65,311.52c13.56,13.4-7.87,39.28-19.15,79.92-8.51,30.66.74,40.85-11.34,60.19-12.44,19.92-96.16-12.48-145.59-17.78-44.49-4.78-110.12-3-99.23-36.94,14.46-45.1-12.68-134.88,22-137.85,36.4-3.12,88.07,18.23,126.55,24.74C655.94,291.77,717.69,293.79,735.65,311.52Z"
          fill="#fff"
        />
        <path
          d="M203.6,274.13c-9.13,9.22,2,31.72,17.26,50.75,13.14,16.4,5.39,30.59,18.73,43.4,11.72,11.27,54.28,4.5,95.4-8.14,30.86-9.48,69.53-3.23,76-24.81,7.28-24.12,6.1-85.8-19.58-88.68-24.71-2.77-57.87,9.41-86.41,13.92C267.6,266.5,214.72,262.9,203.6,274.13Z"
          fill="url(#Unnamed_Pattern-3)"
        />
        <path
          d="M182.77,313.13c-14.31,13.31.39,43.32,17.92,82.34,13.12,29.19,9.65,48.39,29.29,68,17.27,17.26,76.74,4,133.8-18.56,42.82-16.91,97.69-9.23,105.41-44,8.63-38.84,2.84-137.1-33.54-140.07C397.5,257.76,353.83,280,313.5,286.54,264.21,294.51,208.59,289.13,182.77,313.13Z"
          fill="#fff"
        />
        <path
          d="M548.74,550.66c1.86,9.91,5.49,19.35,8.64,28.9a140.27,140.27,0,0,1,4.06,14.49,136,136,0,0,1,2.36,15.68c.57,5.88.88,11.77,1.15,17.66,0,.31.5.31.49,0-.48-10.4-1.07-20.84-3-31.08-1.93-10-5.54-19.56-8.72-29.23a128.37,128.37,0,0,1-4.47-16.55c-.06-.31-.52-.18-.47.13Z"
          fill="#171b3d"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M554.22,540.87c1-.81,2.35.26,3.09,1s1.59,1.57,2.37,2.36q2.16,2.2,4.25,4.49,4.25,4.65,8.15,9.62a168.76,168.76,0,0,1,14.15,21.09q3.48,6.17,6.45,12.6c.14.28.55,0,.42-.25a170,170,0,0,0-29.26-43.88c-1.69-1.83-3.42-3.63-5.18-5.38-1.12-1.11-3.08-3.32-4.78-2-.24.2.1.54.34.34Z"
          fill="#171b3d"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M375,505.63c-11.1,9.33-19.24,21.48-26.21,34.07-7.1,12.84-13.13,26.25-20.57,38.91a132.58,132.58,0,0,1-14.19,20.11c-.2.23.14.58.34.34,9.65-11,16.7-24,23.35-37s12.94-26.18,21.37-38.1a95.16,95.16,0,0,1,16.25-18c.24-.2-.1-.54-.34-.34Z"
          fill="#171b3d"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M344.34,515.53a63.88,63.88,0,0,1,13-10.12.24.24,0,0,0-.24-.42A64.24,64.24,0,0,0,344,515.19c-.22.22.13.56.34.34Z"
          fill="#171b3d"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M548.63,422.19c-4-4.11-4.8-10-4.62-15.45,0-.31-.47-.31-.48,0-.18,5.62.71,11.58,4.76,15.79.22.23.56-.11.34-.34Z"
          fill="#ce5f4c"
        />
        <path
          d="M542,287.09a40.46,40.46,0,0,0,1.82,7.66,53.3,53.3,0,0,0,3.08,6.91c2.49,4.86,3,10.17,3.45,15.54,0,.31.5.31.48,0-.4-5.14-.85-10.35-3.14-15.05a68.45,68.45,0,0,1-3.36-7.4,40.17,40.17,0,0,1-1.86-7.79c0-.31-.51-.18-.47.13Z"
          fill="#d3eae5"
        />
        <path
          d="M593.41,367.93c5-7.25,12.92-12,20.31-16.41a237.83,237.83,0,0,1,24.58-12.94q7.31-3.31,14.81-6.13c.29-.11.17-.57-.13-.46a239.68,239.68,0,0,0-25.82,11.46q-6.35,3.29-12.5,6.94c-3.92,2.33-7.83,4.73-11.53,7.4A41.61,41.61,0,0,0,593,367.68c-.17.26.25.5.42.25Z"
          fill="#e6e6e6"
        />
        <path
          d="M597.21,377.57a219.75,219.75,0,0,1,33.25-.75c.31,0,.31-.47,0-.49a221.07,221.07,0,0,0-33.25.76c-.3,0-.31.51,0,.48Z"
          fill="#e6e6e6"
        />
        <path
          d="M371.71,378.21a143.51,143.51,0,0,1,3.83-35.58q1.15-4.9,2.67-9.72a.24.24,0,0,0-.47-.13A143.92,143.92,0,0,0,371.41,368q-.27,5.1-.18,10.22c0,.31.49.31.48,0Z"
          fill="#60657b"
        />
        <path
          d="M303.61,344.89A144.39,144.39,0,0,1,337,370.42q4.11,4.21,7.85,8.76c.2.24.54-.1.34-.34a144.8,144.8,0,0,0-31-28.1q-5-3.35-10.26-6.26a.24.24,0,0,0-.24.41Z"
          fill="#e6e6e6"
        />
        <path
          d="M244,277.62c11.64-3,23.72-2.67,35.62-3.51,6.1-.43,12.14-1.31,18.19-2.17l18.58-2.63,20.94-3c.31,0,.18-.51-.13-.47l-37.16,5.27c-6.23.88-12.45,1.85-18.72,2.36-5.94.48-11.9.61-17.84,1a101,101,0,0,0-19.6,2.7.24.24,0,0,0,.12.46Z"
          fill="#e9e3ef"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M594.62,272.41A63.63,63.63,0,0,0,612,277.07c6.33.94,12.69,1.67,19.05,2.4,13.13,1.53,26.29,2.68,39.46,3.82l22.36,1.94c.31,0,.3-.45,0-.48-13-1.13-26.07-2.23-39.1-3.41s-26-2.62-38.95-4.36c-6.82-.91-13.69-2.1-20-5-.28-.13-.53.29-.25.42Z"
          fill="#e9e3ef"
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M554.92,496c2.85-11.51,4.48-23.28,7.14-34.82.76-3.29,1.6-6.56,2.58-9.79a.24.24,0,0,0-.47-.13c-3.42,11.36-5.19,23.11-7.52,34.71-.67,3.32-1.39,6.62-2.2,9.9a.24.24,0,0,0,.47.13Z"
          fill="#d0bdb1"
        />
        <path
          d="M562,492.85a58.91,58.91,0,0,1,18.69-18.22,60.92,60.92,0,0,1,6.6-3.46c.28-.12,0-.54-.25-.42a59.27,59.27,0,0,0-21.07,15.91,58,58,0,0,0-4.39,5.94c-.17.26.25.51.42.25Z"
          fill="#d0bdb1"
        />
        <path
          d="M218.5,447.2c3.14,3.93,5.38,8.44,8.07,12.66a68.54,68.54,0,0,0,9.24,11.49c.24.24.62-.13.38-.37a67.4,67.4,0,0,1-9.47-11.89c-2.58-4.11-4.8-8.46-7.84-12.26-.22-.27-.59.11-.38.37Z"
          fill="#e5dded"
        />
        <path
          d="M241.15,458.59c-2.09-4.59-5.81-8.9-5.28-14.25,0-.34-.5-.34-.54,0-.53,5.45,3.23,9.84,5.36,14.52.14.31.6,0,.46-.27Z"
          fill="#e5dded"
        />
      </g>
      <g id="People">
        <path
          d="M449.1,357.22c5-11.69,10.39-24.62,8.24-37.59-1.61-9.73-8.88-19.25-19-20.8a3.74,3.74,0,0,0-1.3,0c-3.13-4.25-8.22-7.48-12.43-9.94-12.43-7.25-28.9-9.57-41.07-.43-3.16,2.37-5.3,5.75-8.4,8.14a14,14,0,0,1-5.15,2.5c-1.93.49-4,.29-5.87,1.05-3.18,1.31-4.16,4.36-4.47,7.54-.34,3.42-.89,6.46-3.16,9.2-4,4.82-11.72,5.6-12.95,12.68a14.08,14.08,0,0,0,.26,5.09c.25,1.28,1.05,3.1.62,4.4-.72,2.18-4.42,2.87-6.19,4.05a8.22,8.22,0,0,0-4,7c.07,3,1.82,5.38,2.94,8.08,1.6,3.88-3,4.14-5.83,4.59a14.84,14.84,0,0,0-8.71,4.25c-4.58,4.86-5.43,12-3,18.12,2.87,7.11,9.16,11.88,15.86,15.15,7.43,3.62,15.31,6.69,23,9.71,6.6,2.58,14.53,4.61,21.13.91,2.86-1.6,5.27-4.29,5.67-7.64.21-1.74-.28-3.32.56-4.92.71-1.34,1.79-2.46,2.57-3.77a8.54,8.54,0,0,0,.6-8.51c-1.48-3-3.16-5.72-.32-8.65,2.61-2.7,5.94-4.16,5.91-8.49a13.25,13.25,0,0,0-1.48-5.24c-.4-.92-1.45-2.55-1.15-3.61s2.15-2,3-2.67a12.06,12.06,0,0,0,2.9-2.8c2.11-3.22.71-6.1-1.41-8.82-2.87-3.68-4.21-7.62-.11-11,3.5-2.92,8.48-3.59,12.67-5A77.72,77.72,0,0,0,430.79,318c-5.73,11.9-14.58,22.38-21.91,33.31-11.37,16.93-19,37.75-12.52,58.14,1.46,4.59,3.86,9,7.67,12s8.79,4.49,13.75,5c8.27.86,19.35.4,24.63-7.1,7-9.93-2.6-19.64-4.83-29.13-1.38-5.86,1.25-11.7,3.81-16.84C444.06,368.08,446.74,362.74,449.1,357.22Z"
          fill="#dbc3a1"
        />
        <g>
          <path
            d="M296.56,434.68,448,434.07a12.63,12.63,0,0,0,2.95-.41s27.42,25.62,143.51-12.88c0,0,12.85-1.85,20.92,16.94,0,0-25.51,15.23-65.64,31.65-30.74,12.57-76.93,12.48-91.44,22.07l-2.25,3.62c-2.48,34.56-6.48,71.34-5.3,93.64,1.78,33.82,8.53,94.87,8.53,94.87-20.13,6.21-44.3,0-67.28,4.73-45,9.31-97.64-2.21-97.64-2.21,2.69-14.74,3.42-57.13,3.42-57.13-3.17-51.11-2.38-52.66-4.14-86.63C293.68,542.33,279.61,461.4,296.56,434.68Z"
            fill="#4f4948"
          />
          <g>
            <path
              d="M517.32,497a16.46,16.46,0,0,1-8.22,2.44,22.63,22.63,0,0,0-8.9,1.74.58.58,0,0,1-.49-1.06,21.14,21.14,0,0,1,8.33-1.8,16.9,16.9,0,0,0,8.8-2.37c.62-.39,1.1.66.48,1.05Z"
              fill="#875348"
            />
            <path
              d="M521.41,507.07c-6.19,1.08-12.48,1.79-18.74,1a.58.58,0,0,1,.18-1.15c6.16.79,12.35.06,18.43-1,.74-.13.86,1,.13,1.15Z"
              fill="#875348"
            />
            <path
              d="M519.84,515.79a37.41,37.41,0,0,1-9.1,1.45c-2.9.12-5.95.3-8.74-.59-.72-.23-.24-1.3.47-1.07,2.67.85,5.7.62,8.47.48a35.65,35.65,0,0,0,8.46-1.35c.72-.22,1.15.86.44,1.08Z"
              fill="#875348"
            />
            <path
              d="M514.9,523.55c-2.5.2-5,.38-7.49.49a24.41,24.41,0,0,1-7-.53c-.72-.19-.54-1.34.19-1.15a23.62,23.62,0,0,0,6.92.51c2.41-.11,4.82-.29,7.23-.48.74-.06.87,1.1.13,1.16Z"
              fill="#875348"
            />
          </g>
          <path
            d="M456.25,674.4a162.26,162.26,0,0,1-38.23,4c-6.59-.13-13.16-.8-19.75-.78-7.39,0-14.67,1.06-22,2-26.61,3.54-52.63.37-79-3.57-.62-.1-.36-1,.25-.94,13.87,2.07,27.77,4.14,41.77,5s27.38-.2,41.14-2c11.54-1.51,22.63-1.23,34.22-.79A161.72,161.72,0,0,0,456,673.46c.61-.14.87.8.26.94Z"
            fill="#bf4430"
          />
          <path
            d="M460.24,488.61a53,53,0,0,0,6.53-32.56c-.07-.63.9-.62,1,0a54,54,0,0,1-6.66,33.06.49.49,0,0,1-.85-.5Z"
            fill="#bf4430"
          />
          <path
            d="M454.8,504.17c-28.55,6.05-57.71,11.43-86.95,7.6-.62-.08-.62-1,0-1,29.15,3.81,58.22-1.53,86.69-7.57.61-.13.87.81.26.94Z"
            fill="#f9f5ec"
          />
          <path
            d="M355.92,507.42c-4,.61-6.41,4.54-8.58,7.58a52.83,52.83,0,0,0-6.74,11.58c-.22.59-1.17.33-.94-.25a56.13,56.13,0,0,1,7.24-12.39c2.22-3.09,4.69-6.85,8.76-7.46.61-.09.88.85.26.94Z"
            fill="#bf4430"
          />
          <g>
            <path
              d="M451,433.66c-6.6-10.94-50.73-14.28-50.73-14.28-.65-24.94,8.18-51.28,8.18-51.28L374.05,364l-8.67,36.06-.2.83c-62.4,19-68.62,33.77-68.62,33.77,6.84,3.3,49.23,20.09,78.26,20.09C417.82,454.77,451,433.66,451,433.66Z"
              fill="#d69b6d"
            />
            <path
              d="M403.2,388.77l-.64,3.46c-16.71-1.69-21.3-22.23-21.3-22.23C386.88,371.82,403.2,388.77,403.2,388.77Z"
              fill="#9e695c"
              opacity={0.2}
              style={{
                mixBlendMode: "multiply",
              }}
            />
            <path
              d="M378.37,352.81a36.8,36.8,0,0,0,1.84-5.67c2.53-21.4,17.65-35.5,34-35.25,10.35.16,17.78.62,21.64,6.5,3.24,4.93,3.78,14.46,3.13,23.14-.6,8.06,2.64,11.82,5.7,16.36a2.51,2.51,0,0,1-3,3.62l-2.76-.59a1.18,1.18,0,0,0-1.4.86,57,57,0,0,1-6,14.8c-5.46,9-12,17-26.56,12.78-16.22-4.67-24.59-20.94-27.53-26.86A77.62,77.62,0,0,1,378.37,352.81Z"
              fill="#d69b6d"
            />
          </g>
          <path
            d="M397,514.33c2.37,11.42,3.24,23.22.74,34.7-.14.61-1.08.35-.94-.26,2.46-11.31,1.59-22.94-.74-34.18-.13-.62.81-.88.94-.26Z"
            fill="#bf4430"
          />
        </g>
        <g opacity={0.15}>
          <path
            d="M642.56,585.68c1.62,17.73-6.8,34-14.7,49-7.72,14.71-16.61,31.1-30.33,40.64-.79.55-1.53-.78-.75-1.32,13.49-9.38,22.21-25.63,29.8-40.09,7.79-14.86,16.1-30.78,14.5-48.26-.09-1,1.39-1,1.48,0Z"
            fill="#281a24"
          />
        </g>
        <path
          d="M574.77,417.58l-65.6,0c-17.78,26.12-34.12,38-38.25,105.38-2.92,47.58,3.34,56.6,4.08,79.58,0,0,30,46.57,51.77,34.16,18.46-10.54-13.83-50.53-2.73-109.38C534.72,470.62,572.91,457.66,574.77,417.58Z"
          fill="#a02410"
        />
        <path
          d="M519.87,389.16l-.25,18c0,2.14-1.12,8.18-10.45,10.39,0,0,11.15,12,28.7,12.26,28.33.43,36.9-12.22,36.9-12.22l-5.35-1.31a13.31,13.31,0,0,1-10.23-13.17l.22-22.12Z"
          fill="#dba795"
        />
        <path
          d="M559.29,392.66c-8.83,8.14-25.16,17.25-39.57,7.21l.1-7.24,39.51-10.69Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M564.07,375.33s-8.87-.12-11.66-8.38c0-.11-12.61-45.6-28.21-45.18-18.49.5-26.18,6.67-27.45,25.49-.54,8-4.11,11.2-7.62,15.21-1.38,1.57.08,4.47,2.3,4l2.68-.19a1.15,1.15,0,0,1,1.21,1c1.19,10.63,6.46,25.27,9.8,27.77,2.08,1.56,9.88,3.67,17.1,3.88C549.85,399.7,564.07,375.33,564.07,375.33Z"
          fill="#dba795"
        />
        <path
          d="M573.62,307.42c-7.84-10.59-21-14.95-37.47-12.43,0,0-18,3.84-24.88,4.23-.16,0-4.6,23.2-4.6,23.2a40.83,40.83,0,0,1,12,7.26c4.93,4.25,8.45,13.81,9.15,18.69.24,1.67.41,3.9.51,5.46,0,.1,0,.22,0,.32,4.34,6.47,7.13,0,7.21.06-.06-.87,0-1.68-.09-2.62,0-.09,0-.2,0-.29s7.61,3,8.34,7.58c2.17,13.78,13.5,26.46,20.22,26.21,14.78-.54,12.72-22.41,18.76-40.68C587.65,329.8,581.42,318,573.62,307.42Z"
          fill="#061a47"
        />
        <path
          d="M550.35,354.07a7.21,7.21,0,0,1-8.17,6.37,7.88,7.88,0,0,1-6.74-8.27c.11-4.46,3.32-8.07,7.15-7.89C549.61,344.61,550.91,349.81,550.35,354.07Z"
          fill="#dba795"
        />
        <path
          d="M544.37,352.81a1.88,1.88,0,0,0-1.25-1.44,2.58,2.58,0,0,0-1-.09,4.87,4.87,0,0,1,1.49-2c.33-.27,0-.85-.36-.57a5.58,5.58,0,0,0-1.83,2.53,6.8,6.8,0,0,0-.08,3.44c.08.43.72.22.64-.2a6.57,6.57,0,0,1-.05-2.5,3.58,3.58,0,0,1,.45,0h.2l.25.05.1,0,.05,0h0l.18.1.08.05h0l0,0,.15.15,0,0,0,.07a1,1,0,0,1,.1.17l0,0,0,.08a1.33,1.33,0,0,1,.05.19.25.25,0,0,1,0,.07v0c0,.07,0,.14,0,.21a1,1,0,0,1,0,.17v0s0,.08,0,.12a1.6,1.6,0,0,1-.05.21l0,.1,0,.05c0,.07-.07.13-.1.2l-.06.09h0l0,.05a.34.34,0,0,0,0,.48.34.34,0,0,0,.48,0A2.38,2.38,0,0,0,544.37,352.81Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M505.2,330.16A18.71,18.71,0,0,1,495.84,312c.39-5.28.74-12.85,8.22-15.15,3-.93,14.31-12.72,23.56-11.58,8.3,1,13.38,6.45,22.25,8.31,13.74,2.87,20.68,7.36,21.35,12.5s-1.94,9.65,1.73,16c4.27,7.42,8,8.46,9.76,14.36.94,3.16-1.13,3.61-4.65,14.57-2.66,8.27-.61,13.87-3.21,15.22-5.18,2.71-8.64-4.63-13.49-5.49-6.28-1.1-11.36-4.25-11.89-5-3.64-4.89,2-10.87-1.07-13.89-3.35-3.34-10.66,3.56-21.53,1.12-6.73-1.52-15-1.05-16.95-2.67C503.68,335.09,509.14,332.57,505.2,330.16Z"
          fill="#02594f"
        />
        <path
          d="M528.16,351.43,511.52,351c-1.11-3.16-3.44-5.46-6.32-5.78-4.26-.46-8.19,3.52-9,9l-1-.09c-.22.5-.65,1.16-.9,1.8l1.72.19c-.07,5.3,2.91,9.76,7,10.21,4.43.49,8.52-3.85,9.12-9.67a13.82,13.82,0,0,0-.17-3.88l16.31.41Zm-24.92,13c-3.65-.4-6.21-4.62-5.72-9.4s3.84-8.35,7.48-7.95,6.21,4.62,5.73,9.4S506.88,364.85,503.24,364.45Z"
          fill="#f4e2ca"
        />
        <g clipPath="url(#clip-path)">
          <path
            d="M476.28,586.48a107.94,107.94,0,0,1-18.36-2c-5.18-.88-10.43-2-14.74-5.3-.89-.68,0-2.23.87-1.55,4.2,3.18,9.29,4.27,14.32,5.12a104.78,104.78,0,0,0,17.91,1.89.9.9,0,0,1,0,1.79Z"
            fill="#f9f5ec"
          />
          <path
            d="M509.17,417.54c-52.17,1-72,85.27-83.17,84-21.21-2.49-63.67-5-63.67-5-14.35-1.65-19.93,24.91-19.93,24.91,2,33.88,18.28,54.28,36.55,55.1,36.41,1.63,90.05-15,99.05-66,0,0,12.54,66.2,16,110,0,0,10.23,8.08,8-4-5.49-29.69-23.28-43.87-21.95-85.08C482.2,464.67,509.17,417.54,509.17,417.54Z"
            fill="#a02410"
          />
          <path
            d="M474.06,613.61a88.85,88.85,0,0,1-35.17-4.46c-1.06-.35-.61-2.08.46-1.72a87.84,87.84,0,0,0,34.71,4.39c1.11-.09,1.1,1.71,0,1.79Z"
            fill="#f9f5ec"
          />
        </g>
        <g opacity={0.35}>
          <path
            d="M448.63,620.68c5.7.65,11,1.71,16,4.83A71.44,71.44,0,0,1,478,636.76c.56.59-.31,1.49-.87.9a71.66,71.66,0,0,0-12.71-10.77,28.14,28.14,0,0,0-7.12-3.42,49,49,0,0,0-8.65-1.51c-.79-.09-.79-1.37,0-1.28Z"
            fill="#281a24"
          />
        </g>
        <g clipPath="url(#clip-path-2)">
          <path
            d="M574.77,417.58s25.07,1.3,36.2,8.6c48.39,31.73,54.42,128.36,42,147.32-16.26,24.88-38.25,32.22-38.25,32.22-6.3,61.22,10.08,108.94,10.08,108.94-7.89,7.87-32.51.87-54.6,7.19a234.62,234.62,0,0,1-74.59,8.26c6.61-23.7,20-47.63,18.74-84.74-2.31-67.11-5.64-70.17,8.82-134.87C529.15,483.86,534.85,460.6,574.77,417.58Z"
            fill="#a02410"
          />
          <path
            d="M666.79,580.52c-5.46,4.85-13.58,6.46-20.29,8.67-8.72,2.86-17.54,5.37-26.4,7.68-18,4.71-36.19,8.86-54.3,13.21-1.08.26-1.54-1.47-.46-1.73,16.83-4,33.7-7.94,50.48-12.22,8.28-2.11,16.54-4.36,24.71-6.91q5.52-1.71,11-3.61c4.73-1.63,10.21-3,14-6.36.84-.74,2.07.52,1.23,1.27Z"
            fill="#f9f5ec"
          />
          <path
            d="M577.85,622.67c.14,32.43,1.86,65.67,11.25,96.86a.87.87,0,0,1-1.67.47c-9.43-31.32-11.16-64.76-11.31-97.33a.87.87,0,0,1,1.73,0Z"
            fill="#f9f5ec"
          />
          <path
            d="M504.74,733.93a166.34,166.34,0,0,1-4.1-33,.87.87,0,1,1,1.73,0,163.82,163.82,0,0,0,4,32.52c.27,1.12-1.4,1.59-1.66.47Z"
            fill="#f9f5ec"
          />
          <path
            d="M555,598.46c-7.42.24-14.85.66-22.27.67-3.46,0-6.9-.41-10.35-.45a50,50,0,0,1-9.93-.7c-1.08-.24-.62-2,.46-1.73,3.52.76,7.07.55,10.64.66,3.34.09,6.66.46,10,.42,7.15-.08,14.3-.43,21.45-.66,1.11,0,1.11,1.76,0,1.79Z"
            fill="#f9f5ec"
          />
          <path
            d="M616.83,627.78c-33.6,8.59-69.38,9.56-103.59,3.93-1.09-.18-.63-1.91.46-1.73,33.86,5.58,69.42,4.57,102.67-3.93a.9.9,0,0,1,.46,1.73Z"
            fill="#f9f5ec"
          />
          <path
            d="M618.41,663.68c-17,3.68-34,8.27-51.38,9.06-18.8.85-37.88-1.66-56.62-3-1.1-.08-1.11-1.87,0-1.79,18.1,1.28,36.48,3.64,54.63,3.07,17.93-.57,35.44-5.29,52.91-9.08,1.09-.24,1.55,1.49.46,1.73Z"
            fill="#f9f5ec"
          />
          <path
            d="M624,698c-8.82,4.44-18,8.44-27.75,9.91-11.53,1.72-23.2,1.51-34.77,3.42-21.06,3.48-42,8.42-63.41,4.55-1.09-.2-.63-1.93.46-1.73,21.82,4,43.3-1.53,64.81-4.93,9.45-1.49,18.85-1.77,28.35-2.59,11.18-1,21.43-5.14,31.44-10.18,1-.5,1.87,1,.87,1.55Z"
            fill="#f9f5ec"
          />
          <path
            d="M613.81,607.24c-14.71,8.21-30.75,14.87-47.21,18.06-.93.18-1.33-1.3-.39-1.48,16.34-3.17,32.25-9.76,46.85-17.9a.76.76,0,0,1,.75,1.32Z"
            fill="#c4432d"
          />
          <path
            d="M606.79,425.71c-10.75,3.5-17.54,10-20.17,21.48-2.41,10.56-1.58,22.22.42,32.77,4.29,22.69,17.25,41.12,28.76,60.43a.75.75,0,0,1-1.28.78c-7-11.77-14.85-23.35-20.89-35.69a101.86,101.86,0,0,1-9.29-33.66c-1.1-10.32-1.15-21.72,2.85-31.45,3.69-8.94,10.55-13.32,19.21-16.15.91-.29,1.3,1.19.39,1.49Z"
            fill="#281a24"
            opacity={0.15}
          />
        </g>
        <path
          d="M566.3,616.8a26.05,26.05,0,0,1,.85,7.76.74.74,0,1,1-1.48,0,24.62,24.62,0,0,0-.8-7.35.74.74,0,0,1,1.43-.41Z"
          fill="#c4432d"
        />
        <path
          d="M506.55,428.13s28.89,22.27,69.21,3.61"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          opacity={0.15}
        />
        <path
          d="M288.67,459.4s2-28.23,13.78-31.89c0,0,23.5-16.56,30.43-16.22s23.66,30.52,79.26,8.7c0,0,28.72,2.51,38.49,11.29a30.11,30.11,0,0,0,7.89,5.28c3.53,1.57,7.21,3.63,13.12,4.21,0,0-48.08,42.53-49.64,47.73l-128.42-9.58Z"
          fill="#13a89e"
        />
        <path
          d="M435.65,312.42c-4.85-7.16-14.43-9.15-22.81-6.79-10.27,2.9-20,10.1-27.73,17.27a67.07,67.07,0,0,0-17.26,25c-4.36,11.43-3.18,23.8-6.22,35.5a29.36,29.36,0,0,1-7.77,14.1c-3,3-6.38,7.73-2.84,11.7,1.76,2,4.75,2.83,7.13,3.82a42.27,42.27,0,0,0,8.84,2.8,22.11,22.11,0,0,0,15.81-2.62c9.67-6,13.09-17.67,12.21-28.51-.45-5.61-2.23-12,.38-17.36,2.11-4.31,7.63-5.09,10.1-9.18,3-4.89,0-9.39-2.43-13.7-1.12-2-1.78-3.87-.12-5.78s4.46-3,6.8-3.95c6.64-2.58,13.34-5,19.92-7.71,4.75-1.95,9.94-5,10.73-10.55A3.72,3.72,0,0,0,435.65,312.42Z"
          fill="#dbc3a1"
        />
        <path
          d="M442.08,315c2.28,2.32,3,5.63,3.71,8.71A40.31,40.31,0,0,1,446.88,334a24.51,24.51,0,0,1-2.57,9.9c-1.33,2.73-2.76,5.46-2.68,8.58,0,1,1.53,1,1.5,0-.1-3.57,2-6.57,3.36-9.73a25.06,25.06,0,0,0,1.91-10.09A46,46,0,0,0,447,322.23c-.72-3-1.62-6-3.84-8.27-.68-.69-1.74.37-1.06,1.06Z"
          fill="#e8ceaf"
        />
        <g>
          <path
            d="M431.32,303.55a46,46,0,0,0-33.09-8.26,42.87,42.87,0,0,0-8.58,2,16.56,16.56,0,0,0-6.58,3.69,7.31,7.31,0,0,0-1.77,3c-.48,1.54-.27,3.32-1.38,4.62-1.39,1.63-3.84,2.05-5.77,2.67s-4.11,1.55-5.32,3.44c-1.36,2.11-1.23,4.77-1.5,7.17a7.42,7.42,0,0,1-4,6.17c-2,1.12-4.11,1.88-5.86,3.31-3.95,3.25-2.21,8.1-1.5,12.37.39,2.36.24,4.72-2.17,5.89-1.2.58-2.54.83-3.69,1.52a6.72,6.72,0,0,0-2.44,2.66c-1.34,2.54-1.42,5.56-2.84,8.07-1.6,2.81-4.47,4.56-7.15,6.2-4.72,2.9-11.38,7.74-9.06,14.23.32.9,1.77.51,1.44-.4-2.19-6.15,4.89-10.36,9.18-13a22,22,0,0,0,6-4.89c1.57-2,2.12-4.38,2.8-6.78a11.43,11.43,0,0,1,1.29-3.2,6.16,6.16,0,0,1,3.4-2.35c2.09-.75,4-1.71,4.71-4,1.26-4.23-2.16-8.59-.69-12.79.79-2.24,3.06-3.34,5-4.32a15.26,15.26,0,0,0,5.16-3.42c1.6-1.89,1.84-4.32,2-6.69s.47-5.1,2.8-6.54c3.35-2.06,8.83-1.71,10.3-6.12.45-1.37.34-2.87,1-4.19a7.52,7.52,0,0,1,2.85-2.91,27.38,27.38,0,0,1,7.91-3,44.64,44.64,0,0,1,36.75,7.19c.78.57,1.53-.73.76-1.29Z"
            fill="#e8ceaf"
          />
          <path
            d="M430.71,310.4a65.83,65.83,0,0,0-17.6,1.12c-5,.9-10.3,1.72-15.05,3.59-3.52,1.39-6.94,3.69-8,7.54-.64,2.38-.16,5-1.07,7.3-.79,2-2.69,3.09-4.61,3.81-3.87,1.45-7.89,2.14-10.49,5.68a11.32,11.32,0,0,0-2.17,5.81c-.21,2.57,1.17,5.32.22,7.82-1.2,3.14-5.12,4.53-7.64,6.39a9.49,9.49,0,0,0-3.11,3.46,8.33,8.33,0,0,0-.17,5.76,39.83,39.83,0,0,1,1.05,4.14,7.61,7.61,0,0,1-1,4.65,20.85,20.85,0,0,0-2.33,7.66c-.57,6,1.26,12.05,3.07,17.73.29.92,1.74.53,1.44-.4-1.58-5-3.17-10.14-3.11-15.42a18.52,18.52,0,0,1,1.63-7.65c1.05-2.23,2.16-4.11,1.83-6.67-.3-2.34-1.48-4.55-1.49-6.92a5.78,5.78,0,0,1,2.19-4.4c2.46-2.18,5.8-3.28,7.92-5.86a6.74,6.74,0,0,0,1.57-4.58c-.07-2.51-.92-4.81-.25-7.32a9.76,9.76,0,0,1,4.09-5.67,22.4,22.4,0,0,1,5.48-2.18c3.64-1.17,7-2.83,7.77-7,.4-2.26.09-4.67,1-6.82a9.38,9.38,0,0,1,4-4.22c4.5-2.65,10.18-3.38,15.22-4.38a69.11,69.11,0,0,1,19.6-1.52c1,.09,1-1.41,0-1.5Z"
            fill="#e8ceaf"
          />
          <path
            d="M417.07,393.47c-2.93,2.78-3.27,6.9-3.57,10.69s-1.08,8.94-5.45,10.09a.75.75,0,0,0,.4,1.45c3.9-1,5.71-5,6.24-8.66.61-4.21.07-9.3,3.44-12.51.7-.67-.37-1.73-1.06-1.06Z"
            fill="#e8ceaf"
          />
          <path
            d="M387.49,356.28a3.13,3.13,0,0,0-1.61,3.11c0,.88.35,1.74.35,2.62,0,1.47-1.13,2-2.27,2.64-3.12,1.73-6.75,3.24-8,6.93a5.5,5.5,0,0,0,.44,4.45,8.92,8.92,0,0,1,1.25,2.82,8.53,8.53,0,0,1-.18,3.26c-.46,2.05-1.31,4-1.85,6a19.72,19.72,0,0,0-.67,5.35,20.52,20.52,0,0,0,3.91,11.8c.56.77,1.86,0,1.29-.76a19.07,19.07,0,0,1-3.67-10c-.24-3.85,1.05-7.1,2.1-10.72a11.72,11.72,0,0,0,.58-4.91,7.3,7.3,0,0,0-.73-2.32,9.23,9.23,0,0,1-1.21-2.51c-.78-4.12,4.22-6.32,7.08-7.87,1.43-.77,3.06-1.6,3.34-3.37.22-1.45-1.19-4.42.57-5.21.88-.39.12-1.68-.76-1.29Z"
            fill="#e8ceaf"
          />
          <path
            d="M438.92,363.25c-3,7.69-6.35,15.32-9,23.15a30.71,30.71,0,0,0-1.82,11.23c.19,3.69.56,7.15-.66,10.72a18,18,0,0,1-7,9.07c-.8.53,0,1.83.76,1.29a19.58,19.58,0,0,0,8.63-16.89c-.07-2-.35-4-.31-6.05a27.2,27.2,0,0,1,1-6.33,113.22,113.22,0,0,1,4.34-11.92l5.44-13.87c.35-.9-1.1-1.29-1.45-.4Z"
            fill="#e8ceaf"
          />
        </g>
        <path
          d="M363.41,434.78s19,8.1,52.64-6.65"
          fill="none"
          stroke="#19bcac"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M307.93,431.14s-9.56.92-11.37,17.25"
          fill="none"
          stroke="#19bcac"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M510.24,319.62c-.38,2.31,1.31,3.87,3.13,5,1.1.67,2.5,1.35,3,2.66s0,2.72.54,4c.81,2,2.77,3.1,4.68,3.79a28.88,28.88,0,0,0,8.31,1.39,37.75,37.75,0,0,0,9.11-.93c2.93-.58,6-1.25,9-.75a9.51,9.51,0,0,1,6.1,3.28c1.79,2.34,1.09,5.31,1.75,8,1.27,5.16,7.14,6,11.63,6.22,1,0,1-1.46,0-1.5-4.45-.2-9.81-1-10.38-6.36-.25-2.3-.11-4.64-1.39-6.68a9.5,9.5,0,0,0-4.51-3.61c-4.77-2-9.79-.52-14.64.35a30.66,30.66,0,0,1-9.27.25c-2.47-.3-5.3-.71-7.39-2.18a4,4,0,0,1-1.85-3.3,6.15,6.15,0,0,0-.82-3.6c-1.32-1.83-5.92-2.95-5.48-5.67.16-.94-1.29-1.35-1.44-.4Z"
          fill="#097263"
        />
        <path
          d="M545.17,324.65c4-.7,8.47-1.24,12.23.73a8.91,8.91,0,0,1,3.65,3.34,12.64,12.64,0,0,1,1.23,5.06c.29,2.87.71,5.94,3.34,7.63s5.89,1.19,8.53.12c.88-.36.5-1.81-.4-1.45-2.93,1.19-7.19,1.6-8.94-1.69-1.52-2.85-.75-6.38-2-9.36-2.89-7.16-11.79-6.92-18.08-5.82-.95.16-.55,1.61.4,1.44Z"
          fill="#097263"
        />
        <path
          d="M356.41,384.33s3.44,26.26-6,22.34-8.45-11-8.45-11Z"
          fill="#dbc3a1"
        />
        <path
          d="M437.7,552.73c-14.67,13.4-147.07-.38-147.07-.38s-6.29-75.06-2-93"
          fill="#13a89e"
        />
        <path
          d="M450,460.34l-30.87,31.8a50.88,50.88,0,0,1-4.08-6.23C413.29,482.8,450,460.34,450,460.34Z"
          fill="#13a89e"
        />
        <path
          d="M509.16,417.57S476.46,416,454,457.15l11.38,1.35Z"
          fill="#a02410"
        />
        <polygon
          points="454 537.5 451 554.5 435.2 552.35 454 537.5"
          fill="#a02410"
        />
        <polygon
          points="416.1 488.15 425.87 501.21 430.27 499.24 454 457.15 439.64 452.82 416.1 488.15"
          fill="#13a89e"
        />
        <path
          d="M613.84,547.81s-5.85,9.45-19.34,22.07h0"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          opacity={0.15}
        />
        <path
          d="M481.58,449.89a33.26,33.26,0,0,0,0,12.87"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          opacity={0.15}
        />
        <path
          d="M517.61,508.41s-10.39,35.75-30.78,47.92"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          opacity={0.15}
        />
        <path
          d="M496.91,522.87s-1.26,17.17-7.86,21.9"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          opacity={0.15}
        />
        <path
          d="M478,510.5s-.15,12.07-7.57,22"
          fill="none"
          stroke="#281a24"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          opacity={0.15}
        />
        <path
          d="M325,483.5s25,41,67.23,28.54"
          fill="none"
          stroke="#19bcac"
          strokeMiterlimit={10}
        />
        <path
          d="M425.87,481.5s-1.78,6.18,2.67,10.64"
          fill="none"
          stroke="#19bcac"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <path
            d="M58.21,561.46l-5,2,1.43,3.61,5-2a1.12,1.12,0,0,0,.63-1.46l-.61-1.53A1.12,1.12,0,0,0,58.21,561.46Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M63.79,569.64A8.5,8.5,0,0,1,59,566.71l-.16-.19a2.65,2.65,0,0,0-3-.79L27.53,577a2.66,2.66,0,0,0-1.67,2.65l0,.24a8.44,8.44,0,0,1-1.49,5.43h0a2.66,2.66,0,0,0-.28,2.49l17.18,43.28a2.66,2.66,0,0,0,1.91,1.61h0A8.56,8.56,0,0,1,48,635.59l.15.19a2.65,2.65,0,0,0,3,.78l28.27-11.22a2.66,2.66,0,0,0,1.66-2.65l0-.24a8.5,8.5,0,0,1,1.5-5.44h0a2.64,2.64,0,0,0,.28-2.48L65.7,571.25a2.62,2.62,0,0,0-1.91-1.61Z"
              fill="url(#New_Pattern_Swatch_8)"
            />
            <path
              d="M63.79,569.64A8.5,8.5,0,0,1,59,566.71l-.16-.19a2.65,2.65,0,0,0-3-.79l-6,2.4a2.64,2.64,0,0,1,3,.79l.16.19A8.5,8.5,0,0,0,57.75,572a2.62,2.62,0,0,1,1.91,1.61l17.19,43.28a2.62,2.62,0,0,1-.29,2.48h0a8.55,8.55,0,0,0-1.49,5.44l0,.24a2.66,2.66,0,0,1-1.66,2.65l6-2.4a2.66,2.66,0,0,0,1.66-2.65l0-.24a8.5,8.5,0,0,1,1.5-5.44h0a2.64,2.64,0,0,0,.28-2.48L65.7,571.25A2.62,2.62,0,0,0,63.79,569.64Z"
              fill="#9fa2a5"
            />
            <path
              d="M41.72,631.77a2.65,2.65,0,0,0,1.48.89h0A8.51,8.51,0,0,1,48,635.59l.15.19a2.65,2.65,0,0,0,3,.78l28.27-11.22a2.66,2.66,0,0,0,1.66-2.65l0-.24a8.5,8.5,0,0,1,1.5-5.44h0a2.61,2.61,0,0,0,.46-1.66Z"
              fill="#e5ebf6"
            />
            <path
              d="M82.74,616.79a.83.83,0,0,0,.07-.13l0,0a1.42,1.42,0,0,0,.08-.18h0a1.05,1.05,0,0,0,0-.19l0,0a1,1,0,0,1,0-.17v0l0-.21h0c0-.06,0-.13,0-.2v0a1.41,1.41,0,0,0,0-.2l-6,2.4a2.56,2.56,0,0,1-.47,1.66h0a8.55,8.55,0,0,0-1.49,5.44l0,.24a2.66,2.66,0,0,1-1.66,2.65l6-2.4.38-.19a2.08,2.08,0,0,0,.34-.24l.16-.14.27-.31.11-.17a2.65,2.65,0,0,0,.41-1.38,1.62,1.62,0,0,0,0-.22l0-.24a8.33,8.33,0,0,1,.07-1.8,7.85,7.85,0,0,1,.22-1c0-.11.06-.23.1-.34a8.37,8.37,0,0,1,.55-1.32,7.4,7.4,0,0,1,.56-.93h0l.1-.17Z"
              fill="#d1dced"
            />
            <path
              d="M59.65,565.08l-35.37,14a1.12,1.12,0,0,1-1.46-.63L22.21,577a1.12,1.12,0,0,1,.63-1.46l35.37-14a1.12,1.12,0,0,1,1.46.63l.61,1.53A1.12,1.12,0,0,1,59.65,565.08Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={52.24}
              cy={597.99}
              rx={14}
              ry={18.81}
              transform="translate(-217.01 61.5) rotate(-21.66)"
              fill="#ffdc6c"
            />
            <path
              d="M45.3,580.51a10.76,10.76,0,0,0-2.8,1.65c6.46-.46,13.49,4.77,16.77,13S61,612.1,56,616.2a10.71,10.71,0,0,0,3.18-.72c7.18-2.86,9.9-13,6.06-22.65S52.49,577.65,45.3,580.51Z"
              fill="#f7ce5e"
            />
            <path
              d="M67,597.74,41.35,607.91a2.32,2.32,0,0,1-3-1.3l-2.12-5.35a2.31,2.31,0,0,1,1.3-3l25.62-10.18a2.32,2.32,0,0,1,3,1.31l2.12,5.34A2.33,2.33,0,0,1,67,597.74Z"
              fill="#fff"
            />
            <path
              d="M63.13,588.07l-3.8,1.51,3.84,9.67,3.8-1.51a2.33,2.33,0,0,0,1.3-3l-2.12-5.34A2.32,2.32,0,0,0,63.13,588.07Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <path
          d="M748,996.06H172.43c-6,0-11.73-5.7-11.73-12.73v-1.59A12.72,12.72,0,0,1,173.43,969H749a12.72,12.72,0,0,1,12.73,12.72v1.59C761.72,990.36,756,996.06,748,996.06Z"
          fill="#351377"
        />
        <path
          d="M744.14,969.5H177.77S136,581.74,177.38,541c18.5-18.23,105.25-1.65,213.05,32.09,60.95,19.07,173.48,13.68,173.48,13.68,29.19-16.16,160.38-1,186.09,17.72C774.62,622.43,744.14,969.5,744.14,969.5Z"
          fill="url(#Unnamed_Pattern-5)"
        />
        <path
          d="M158.45,567.62a9.3,9.3,0,0,0,13.21,10.22c18.39-9,51.7-19.26,76.38,7.94,86.55,95.39,261,188.31,291.6,201.61s95.54,33,143.77-1.6S755,607.67,755,607.67s.81-38.72-55.44-34.2c-57.91,4.66-267.09-17.4-304.69-28.7S302,507.71,269.51,507.54,199.72,510.12,167,550.65C167,550.65,160.89,556.06,158.45,567.62Z"
          fill="#d6c9e2"
        />
        <polygon
          points="381.26 484.56 384.66 495.84 351.49 488.5 353.45 478.43 381.26 484.56"
          fill="#13a89e"
        />
        <path
          d="M305.19,920.59A185.37,185.37,0,0,1,291,830.45c0-.34-.5-.34-.53,0a185.5,185.5,0,0,0,14.25,90.41c.13.32.59,0,.46-.27Z"
          fill="none"
          stroke="#0d3360"
          strokeMiterlimit={10}
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M244.62,889.26a91.6,91.6,0,0,1,18.52-40.54,89.46,89.46,0,0,1,8.56-9.28c.25-.24-.13-.61-.38-.38a92.18,92.18,0,0,0-24,37.58,90.7,90.7,0,0,0-3.22,12.48c-.06.34.45.48.52.14Z"
          fill="none"
          stroke="#0d3360"
          strokeMiterlimit={10}
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M574.88,830.73a215.81,215.81,0,0,0,68.8,93.86c.27.21.65-.17.38-.38a214.33,214.33,0,0,1-32.73-31.85,216.7,216.7,0,0,1-25.4-38.19,214.21,214.21,0,0,1-10.53-23.58c-.12-.32-.64-.18-.52.14Z"
          fill="none"
          stroke="#0d3360"
          strokeMiterlimit={10}
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M465.78,906.66A28.74,28.74,0,0,0,485,923.16a.27.27,0,0,0,.14-.52,28.29,28.29,0,0,1-18.87-16.25c-.13-.31-.6,0-.46.27Z"
          fill="none"
          stroke="#0d3360"
          strokeMiterlimit={10}
          opacity={0.5}
          style={{
            mixBlendMode: "screen",
          }}
        />
        <path
          d="M380,484.56l40.36-4.86L451,554.5l-17-2S386.37,514.62,380,484.56Z"
          fill="#13a89e"
        />
        <path
          d="M430.27,499.24l-35.4,45.53S442,555.5,451,554.5V508.14Z"
          fill="#a02410"
        />
        <polyline
          points="430.27 499.24 428.74 501.21 425.52 498.53 430.27 497.66 430.27 499.24"
          fill="#13a89e"
        />
        <path
          d="M432,349.63a1.55,1.55,0,1,1-1.51-1.87A1.72,1.72,0,0,1,432,349.63Z"
          fill="#382632"
        />
      </g>
      <g id="eyes">
        <path
          d="M433.46,340.73c.42-1.1.06-1.52-1.55-1.8a12.43,12.43,0,0,0-5,.42c-3.34,1-6,4.11-5,3.58a18.58,18.58,0,0,1,7.16-2.41C430.89,340.3,433.37,341,433.46,340.73Z"
          fill="#513715"
        />
        <polygon
          points="330.26 508.4 309.79 471.37 343.93 460.33 384.04 492.96 410.98 524.08 404.51 532.37 365 526.5 330.26 508.4"
          fill="#13a89e"
        />
        <path
          d="M343.93,484.82S348.2,512.4,361,532.5"
          fill="none"
          stroke="#19bcac"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x={446} y={530.5} width={12} height={12} fill="#a02410" />
        <ellipse cx={431} cy={367} rx={2} ry={1.5} fill="#fff" />
        <path
          d="M503.71,357.73a1.41,1.41,0,0,0,2.26.32,2.31,2.31,0,0,0,.27-2.79,1.41,1.41,0,0,0-2.26-.32A2.31,2.31,0,0,0,503.71,357.73Z"
          fill="#382632"
        />
        <path
          d="M501.82,342.3c-.37-.82.13-1.13,1.72-1.15a15,15,0,0,1,4.78.93c3.12,1.16,4.47,3.51,3.6,3A17.56,17.56,0,0,0,506,343C504.23,342.58,502.07,342.86,501.82,342.3Z"
          fill="#052620"
        />
        <path
          d="M497.43,378.63c.09.23.32.76.32.76,4.55-.44,6.89-3.48,5.65-3a11.87,11.87,0,0,1-6.36.15"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)

export default SvgConsentOneB
